import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectMortgageMiniCalculatorEnabled = (state: IState) => {
  return featureToggleSelector(state).isMortgageCalculatorInObjectCardEnabled;
};
